(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["installation-guide-items-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sectionRootElements = document.querySelectorAll('[data-installation-guide-items-list]');
    for (const sectionRoot of sectionRootElements) {
      const shopifySectionId = sectionRoot.dataset.sectionId;
      /* JSON script: guide rows (groupHandle, groupName, title, pdfUrl) */
      const guideRowsDataElement = document.getElementById(`installation-guide-items-data-${shopifySectionId}`);
      /* JSON script: i18n strings selectCategory, noDocuments, newWindow */
      const messagesDataElement = document.getElementById(`installation-guide-items-msgs-${shopifySectionId}`);
      const groupHeadingElement = document.getElementById(`installation-guide-items-heading-${shopifySectionId}`);
      const pdfLinksListElement = document.getElementById(`installation-guide-items-ul-${shopifySectionId}`);
      const emptyStateElement = document.getElementById(`installation-guide-items-empty-${shopifySectionId}`);
      if (!guideRowsDataElement || !groupHeadingElement || !pdfLinksListElement || !emptyStateElement) continue;

      let messages = { selectCategory: '', noDocuments: '', newWindow: '' };
      if (messagesDataElement) {
        try {
          messages = { ...messages, ...JSON.parse(messagesDataElement.textContent || '{}') };
        } catch {
          /* keep defaults */
        }
      }

      let guideRows = [];
      try {
        guideRows = JSON.parse(guideRowsDataElement.textContent || '[]');
      } catch {
        guideRows = [];
      }

      const getLastUrlPathSegment = () => {
        const urlPathSegments = window.location.pathname.split('/').filter(Boolean);
        if (!urlPathSegments.length) return '';
        return decodeURIComponent(urlPathSegments[urlPathSegments.length - 1] || '');
      };
      const activeGroupHandle = (sectionRoot.dataset.activeGroupHandle || getLastUrlPathSegment() || '').trim();

      const showEmptyStateMessage = (message) => {
        groupHeadingElement.textContent = '';
        groupHeadingElement.hidden = true;
        pdfLinksListElement.innerHTML = '';
        pdfLinksListElement.hidden = true;
        emptyStateElement.textContent = message;
        emptyStateElement.hidden = false;
      };

      if (!activeGroupHandle) {
        showEmptyStateMessage(messages.selectCategory);
        continue;
      }

      const normalizeHandleString = (inputString) => String(inputString || '').trim().toLowerCase();
      const matchedGuideRows = guideRows.filter((guideRecord) =>
        normalizeHandleString(guideRecord.groupHandle) === normalizeHandleString(activeGroupHandle)
      );
      if (matchedGuideRows.length === 0) {
        showEmptyStateMessage(messages.noDocuments);
        continue;
      }

      const groupHeadingDisplayName = matchedGuideRows[0].groupName || activeGroupHandle;
      groupHeadingElement.textContent = groupHeadingDisplayName;
      groupHeadingElement.hidden = false;

      pdfLinksListElement.innerHTML = '';
      for (const guideRow of matchedGuideRows) {
        const listItemElement = document.createElement('li');
        listItemElement.className = 'installation-guide-items-list__item';
        const pdfLinkAnchor = document.createElement('a');
        pdfLinkAnchor.className = 'installation-guide-items-list__link';
        pdfLinkAnchor.href = guideRow.pdfUrl;
        pdfLinkAnchor.target = '_blank';
        pdfLinkAnchor.rel = 'noopener noreferrer';
        pdfLinkAnchor.appendChild(document.createTextNode(guideRow.title));
        const newWindowScreenReaderSpan = document.createElement('span');
        newWindowScreenReaderSpan.className = 'visually-hidden';
        newWindowScreenReaderSpan.textContent = messages.newWindow;
        pdfLinkAnchor.appendChild(newWindowScreenReaderSpan);
        listItemElement.appendChild(pdfLinkAnchor);
        pdfLinksListElement.appendChild(listItemElement);
      }

      emptyStateElement.hidden = true;
      emptyStateElement.textContent = '';
      pdfLinksListElement.hidden = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
